import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRedo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	strokeWidth: 1.5,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#000000",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M19.5 8C15.5 8 13 8 9 8C9 8 9 8 9 8C9 8 4 8 4 12.7059C4 18 9 18 9 18C12.4286 18 14.2857 18 17.7143 18",
		stroke: "#000000",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.5 11.5C17.8668 10.1332 18.6332 9.36683 20 8C18.6332 6.63317 17.8668 5.86683 16.5 4.5",
		stroke: "#000000",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgRedo;
